module.exports = __webpack_public_path__ + "static/media/css.80876750.png";